import { useEffect, useState, type ReactNode } from "react";
import { ensureSandboxSession } from "./sandbox-utils.js";

type Phase = "loading" | "ok";

/** Sesión vía Nest (`/auth/me` en carga). El resto: `checkBffSession` antes de crear widgets en `App`. */
export function AuthGate({ children }: { children: ReactNode }): ReactNode {
  const [phase, setPhase] = useState<Phase>("loading");
  const [showLoginLink, setShowLoginLink] = useState(false);

  useEffect(() => {
    let alive = true;
    const slowTimer = window.setTimeout(() => {
      if (alive) setShowLoginLink(true);
    }, 12_000);

    void ensureSandboxSession().then((ok) => {
      if (!alive) return;
      if (ok) setPhase("ok");
    });

    return () => {
      alive = false;
      window.clearTimeout(slowTimer);
    };
  }, []);

  if (phase === "loading") {
    const loginUrl = new URL("/auth/oidc/login", window.location.origin).href;
    return (
      <div className="sandbox-shell sandbox-auth-loading">
        <p className="sandbox-auth-loading-text">Comprobando sesión…</p>
        {showLoginLink ? (
          <p className="sandbox-auth-loading-fallback">
            <a href={loginUrl}>Ir al inicio de sesión (OIDC)</a>
          </p>
        ) : null}
      </div>
    );
  }

  return children;
}
